function isMobile() {
    return window.innerWidth < 768
}
function isTablet() {
    return window.innerWidth < 1025 && window.innerWidth > 767
}
function isDesktop() {
    return window.innerWidth > 1024
}

export {
    isMobile,
    isTablet,
    isDesktop
}